import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosService from '../../../utility/axiosService/axiosService'
import { API_ENDPOINT } from '../../../utility'
import { toast } from "react-toastify"
const FileDownload = require('js-file-download');

export const getOrders = createAsyncThunk(
    'orders/getOrdersList',
    async (data) => {
        return await axiosService.get(`${API_ENDPOINT}/admin/order`, {
            params: {
                limit: data.limit || 10,
                page: data.page,
                start_date: data.start_date,
                end_date: data.end_date,
                merchant_id: data.merchant_object.value,
                affiliate_id: data.affiliate_object.value,
                product_code: data.productList_object.value,
                search: data.search
            }
        }).then((res) => {
            return res.data.data;
        });
    }
);

export const getDetailOrder = createAsyncThunk(
    'orders/getDetailOrder',
    async (data) => {
        return await axiosService.get(`${API_ENDPOINT}/admin/order/${data}`)
            .then((res) => {
                return res.data.data;
            })
    }
)

export const exportOrdersList = createAsyncThunk(
    'orders/exportOrdersList',
    async (data) => {
        return await axiosService.getExportExcel(`${API_ENDPOINT}/admin/order`, {
            exportExcel: 1,
            page: data.page,
            start_date: data.start_date,
            end_date: data.end_date,
            merchant_id: data.merchant_object.value,
            affiliate_id: data.affiliate_object.value,
            product_code: data.productList_object.value,
            search: data.search
        }).then((res) => {
            console.log(res)
            return res;
        });
    }
);



const ordersSlice = createSlice({
    name: 'orders',
    initialState: {
        loading: false,
        loadingExport: false,
        loadingDetail: false,
        modal: false,
        data: [],
        dataDetail: [],
        error: null,
        total_page: 0,
    },
    reducers: {
        getModal: (state, { payload }) => {
            state.modal = true;
            state.dataDetails = payload;
        },
        removeModal: (state) => {
            state.dataDetails = null;
            state.modal = false;
        }
    },
    extraReducers: {
        [getOrders.pending]: (state) => {
            state.loading = true;
        },
        [getOrders.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload.data;
            state.total_page = payload.total_page;
        },
        [getDetailOrder.pending]: (state) => {
            state.loadingDetail = true;
        },
        [getDetailOrder.fulfilled]: (state, { payload }) => {
            state.loadingDetail = false;
            state.dataDetail = payload;
        },
        [exportOrdersList.pending]: (state) => {
            state.loadingExport = true;
        },
        [exportOrdersList.fulfilled]: (state, { payload }) => {
            state.loadingExport = false;
            FileDownload(payload.data, 'report.xlsx');
        },
        [exportOrdersList.rejected]: (state, action) => {
            state.loadingExport = false;
            state.error = action;
        },
    }
});

export const { getModal, removeModal } = ordersSlice.actions;

export default ordersSlice.reducer;